import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { Model_Meta_Data_Initial_State } from 'src/constants/componentConstants/costModelling'
import {
  getModelMetaDataAsync,
  getModelMetaDataV2Async,
} from 'src/services/costModelling/shouldCostLibrary.services'

const initialState = {
  ...Model_Meta_Data_Initial_State,
  initialModelMetaData: {
    ...Model_Meta_Data_Initial_State.modelMetaData,
  },
}

export const modelMetaData = createSlice({
  name: 'get-model-meta-data',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getModelMetaDataAsync.pending), (state) => {
      state.modelMetaDataLoader = true
    })
    builder.addMatcher(isAnyOf(getModelMetaDataAsync.fulfilled), (state, action) => {
      const modelData = action.payload.data
      const updatedAttachments = modelData?.attachments?.map((attachment) => ({
        ...attachment,
        fileName: attachment.file_name,
      }))

      const updatedModelData = {
        modelName: modelData?.model_name ?? '',
        modelDescription: modelData?.description ?? '',
        manufacturingCountry: modelData?.country ?? '',
        l1: modelData?.l1 ?? '',
        l2: modelData?.l2 ?? '',
        l3: modelData?.l3 ?? '',
        creationDate: modelData?.model_creation_date,
        approachType: modelData?.approach_type ?? '',
        specifications:
          Array.isArray(modelData?.specifications) && modelData.specifications.length > 0
            ? modelData.specifications
            : [],

        attachments:
          Array.isArray(modelData?.attachments) && modelData.attachments.length > 0
            ? updatedAttachments
            : [],
        attachedSkuCount: modelData?.attached_sku_count ?? 0
      }

      state.modelMetaData = updatedModelData
      state.initialModelMetaData = structuredClone(updatedModelData)
      state.modelMetaDataLoader = false
    })
    builder.addMatcher(isAnyOf(getModelMetaDataAsync.rejected), (state, action) => {
      state.modelMetaDataLoader = false
      state.modelMetaDataError = action.payload.message
    })
    builder.addMatcher(isAnyOf(getModelMetaDataV2Async.pending), (state) => {
      state.modelMetaDataLoader = true
    })
    builder.addMatcher(isAnyOf(getModelMetaDataV2Async.fulfilled), (state, action) => {
      const modelData = action.payload.data
      const updatedAttachments = modelData?.attachments?.map((attachment) => ({
        ...attachment,
        fileName: attachment.file_name,
      }))

      const updatedModelData = {
        modelName: modelData?.model_name ?? '',
        modelDescription: modelData?.description ?? '',
        manufacturingCountry: modelData?.country ?? '',
        l1: modelData?.l1 ?? '',
        l2: modelData?.l2 ?? '',
        l3: modelData?.l3 ?? '',
        creationDate: modelData?.model_creation_date,
        approachType: modelData?.approach_type ?? '',
        specifications:
          Array.isArray(modelData?.specifications) && modelData.specifications.length > 0
            ? modelData.specifications
            : [],

        attachments:
          Array.isArray(modelData?.attachments) && modelData.attachments.length > 0
            ? updatedAttachments
            : [],
      }

      state.modelMetaData = structuredClone(updatedModelData)
      state.initialModelMetaData = structuredClone(updatedModelData)
      state.modelMetaDataLoader = false
    })
    builder.addMatcher(isAnyOf(getModelMetaDataV2Async.rejected), (state, action) => {
      state.modelMetaDataLoader = false
      state.modelMetaDataError = action.payload.message
    })
  },
  reducers: {
    resetModelMetaData: () => initialState,
    setModelMetaData: (state, action) => {
      state.modelMetaData = {
        modelName: action.payload.modelName ?? '',
        modelDescription: action.payload.modelDescription ?? '',
        manufacturingCountry: action.payload.manufacturingCountry ?? '',
        l1: action.payload.l1 ?? '',
        l2: action.payload.l2 ?? '',
        l3: action.payload.l3 ?? '',
        creationDate: action.payload.creationDate,
        specifications:
          Array.isArray(action.payload.specifications) && action.payload.specifications.length > 0
            ? action.payload.specifications
            : [],
        attachments:
          Array.isArray(action.payload.attachments) && action.payload.attachments.length > 0
            ? action.payload.attachments
            : [],
      }
    },
  },
})

export const { resetModelMetaData, setModelMetaData } = modelMetaData.actions

export default modelMetaData.reducer
